import { ALL_STAKEHOLDERS } from "../data/constants";
import { C } from "../theme/colors";
import StakeholderCard from "./StakeholderCard";

export default function StakeholderLogosSection({ gsap, setPage, showAll = false }) {
  const shown = showAll ? ALL_STAKEHOLDERS : ALL_STAKEHOLDERS.slice(0, 8);
  return (
    <div style={{background:"white",padding:"37px 40px",position:"relative",overflow:"hidden"}}>
      <div style={{maxWidth:1260,margin:"0 auto",position:"relative"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11,fontWeight:700,letterSpacing:2.5,textTransform:"uppercase",color:C.gold,display:"block",marginBottom:12}}>National Security Ecosystem</span>
          <h2 style={{fontFamily:"Arial,Helvetica,sans-serif",fontWeight:700,fontSize:"clamp(1.6rem,3vw,2.4rem)",color:C.navyDark,lineHeight:1.2,marginBottom:14}}>Key Stakeholders in National Security Domain</h2>
          <div style={{width:48,height:3,background:C.gold,borderRadius:2,margin:"0 auto 16px"}}/>
          <p style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,color:C.textMid,maxWidth:520,margin:"0 auto",lineHeight:1.8}}>India's defence, research, and security organisations united in building self-reliance</p>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,maxWidth:900,margin:"0 auto"}} className="grid-4">
          {shown.map((s, i) => <StakeholderCard key={i} s={s} />)}
        </div>
        {!showAll && (
          <div style={{marginTop:36,display:"flex",flexDirection:"column",alignItems:"center",gap:14}}>
            <p style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:12.5,color:C.textMuted,textAlign:"center"}}>+ BSF, CISF, CRPF, BRO, DAE, Coast Guard, RAW & more</p>
            {setPage && (
              <button onClick={() => setPage("stakeholders")}
                style={{display:"inline-flex",alignItems:"center",gap:8,background:"transparent",color:C.navy,border:`1.5px solid ${C.navy}`,borderRadius:8,padding:"11px 28px",fontFamily:"Arial,Helvetica,sans-serif",fontWeight:600,fontSize:13.5,cursor:"pointer",transition:"all .25s"}}
                onMouseEnter={e=>{e.currentTarget.style.background=C.navy;e.currentTarget.style.color=C.white;}}
                onMouseLeave={e=>{e.currentTarget.style.background="transparent";e.currentTarget.style.color=C.navy;}}>
                View All Stakeholders →
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
